angular.module('leanlaw').factory('templateDefinition', ['singleRequest', function (singleRequest) {
  const cancel = params => {
    // singleRequest.cancel('xyz');
  };
  const load = ({
    columns,
    filter,
    params
  }) => {
    return {
      rows: [{
        id: 1,
        label: 'Group A',
        values: {
          thing: {
            value: randomString(10)
          },
          foo: {
            value: Math.random() * 1000
          },
          bar: {
            value: Math.random() * 20
          }
        },
        rows: [...Array(5)].map(i => ({
          values: {
            thing: {
              value: 'a'
            },
            foo: {
              value: Math.random() * 1000
            },
            bar: {
              value: Math.random() * 20
            }
          }
        }))
      }, {
        id: 2,
        label: 'Group B',
        values: {
          thing: {
            value: randomString(5)
          },
          foo: {
            value: Math.random() * 1000
          },
          bar: {
            value: Math.random() * 20
          }
        },
        rows: [...Array(5)].map(i => ({
          values: {
            thing: {
              value: 'x'
            },
            foo: {
              value: Math.random() * 1000
            },
            bar: {
              value: Math.random() * 20
            }
          }
        }))
      }]
    };
  };
  const structure = ({
    params,
    me
  }) => {
    return {
      sort: 'foo',
      label: `Template`,
      subrow: {
        label: 'Detail',
        title: true,
        default: true
      },
      totals: {
        rows: true,
        totalLabelCells: 1
      },
      showFilters: {
        dateRange: true,
        matterForUser: true,
        distribution: false
      },
      columns: [{
        id: 'thing',
        label: 'Thing'
      }, {
        id: 'foo',
        label: 'Wibble',
        filter: 'amount',
        number: true
      }, {
        id: 'bar',
        label: 'Wobble',
        filter: 'hoursDecimal',
        number: true
      }]
    };
  };
  function randomString(length) {
    return Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length)).toString(36).slice(1);
  }
  function randomDate(start, end) {
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  }
  return {
    structure,
    load,
    cancel
  };
}]);